import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Sparkles, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

interface TrialBannerProps {
  planTier: string;
  trialEndsAt: string;
}

export function TrialBanner({ planTier, trialEndsAt }: TrialBannerProps) {
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(false);

  const daysLeft = Math.max(
    0,
    Math.ceil((new Date(trialEndsAt).getTime() - Date.now()) / (1000 * 60 * 60 * 24)),
  );

  if (isDismissed) return null;

  const tierColors: Record<string, string> = {
    lite: "bg-blue-500/10 border-blue-500/50 text-blue-600",
    pro: "bg-purple-500/10 border-purple-500/50 text-purple-600",
    studio: "bg-amber-500/10 border-amber-500/50 text-amber-600",
  };

  return (
    <Alert className={`relative ${tierColors[planTier] || tierColors.lite}`}>
      <div className="flex w-full items-center justify-between pr-8">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 shrink-0" />
          <span className="text-sm font-medium">You're on a</span>
          <Badge variant="outline">{planTier.toUpperCase()}</Badge>
          <span className="text-sm font-medium">trial</span>
          <span className="text-sm text-muted-foreground">
            · {daysLeft} day{daysLeft !== 1 ? "s" : ""} remaining
          </span>
        </div>
        <Button size="sm" onClick={() => navigate("/upgrade")}>
          Upgrade Now
        </Button>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="absolute right-2 top-1/2 h-6 w-6 -translate-y-1/2"
        onClick={() => setIsDismissed(true)}
      >
        <X className="h-4 w-4" />
      </Button>
    </Alert>
  );
}
